export default () => ({
    currentQuestion: null,
    questions: {},
    questionDone: [],
    questionCounted: [],
});
